/**
* Author: JJ Li
* Date: 2020/04/14
*/

import AES from "crypto-js/aes";
import encBase64 from "crypto-js/enc-base64";
import encUtf8 from "crypto-js/enc-utf8";
import modeCFB from "crypto-js/mode-cfb";
import padPkcs7 from "crypto-js/pad-pkcs7";

// encrypt/decrypt in AES
let iv = encBase64.parse('1234567890qazwsx');

const crypto = {
  encrypt: (value, privateKey = null) => {
    privateKey = (privateKey) ? encBase64.parse(privateKey) : iv;
    value = Number.isInteger(value) ? String(value) : value;
    let encrypted = AES.encrypt(value, privateKey, {
      iv: iv,
      mode: modeCFB,
      padding: padPkcs7
    });

    return encBase64.stringify(encUtf8.parse(encrypted.toString()));
  },
  decrypt: (value, privateKey = null) => {
    privateKey = (privateKey) ? encBase64.parse(privateKey) : iv;
    value = encBase64.parse(value).toString(encUtf8)
    let decrypted = AES.decrypt(value, privateKey, {
        iv: iv,
        mode: modeCFB,
        padding: padPkcs7
    });

    return decrypted.toString(encUtf8);
  }
}

export default crypto;